module.exports = __webpack_public_path__ + "media/ast.482c4aa9.wav";